import { postData } from "./PostData";
import {global} from "./Global";

export const productBundle = () => {
	const miniCart = document.getElementById('mini-cart');

	window.productBundle = () => {
		return {
			regularPrice: parseFloat(0.00).toFixed(2),
			salePrice: parseFloat(0.00).toFixed(2),
			save: 0,
			bundleType: '',

			select(el) {
				let elRegularPrice = parseFloat(el.getAttribute('data-regular-price')).toFixed(2);
				let elSalePrice = parseFloat(el.getAttribute('data-sale-price')).toFixed(2);

				if (el.checked) {
					this.regularPrice = (parseFloat(this.regularPrice) + parseFloat(elRegularPrice)).toFixed(2);
					this.salePrice = (parseFloat(this.salePrice) + parseFloat(elSalePrice)).toFixed(2);
				} else {
					this.regularPrice = (parseFloat(this.regularPrice) - parseFloat(elRegularPrice)).toFixed(2);
					this.salePrice = (parseFloat(this.salePrice) - parseFloat(elSalePrice)).toFixed(2);
				}

				this.save = (this.regularPrice - this.salePrice).toFixed(2);

				let singleBundle = el.closest('.single-bundle');
				let fullPriceSelector = singleBundle.querySelector('.bundle-price .full-price');

				if (parseFloat(this.save) === 0.00) {
					fullPriceSelector.classList.add('hidden');
					return;
				}

				fullPriceSelector.classList.remove('hidden');
			},
			load(el, bundleType) {
				this.bundleType = bundleType;

				let products = el.querySelectorAll('.products-bundle .bundle-product-price');

				products.forEach(function (item, index, arr) {
					let productRegularPrice = item.getAttribute('data-regular-price');
					this.regularPrice = (parseFloat(this.regularPrice) + parseFloat(productRegularPrice)).toFixed(2);

					let productSalePrice = item.getAttribute('data-sale-price');
					this.salePrice = (parseFloat(this.salePrice) + parseFloat(productSalePrice)).toFixed(2);
				}.bind(this));

				this.save = (this.regularPrice - this.salePrice).toFixed(2);
			},
			showPrice() {
				if(this.regularPrice == 0 && this.salePrice == 0) {
					return false;
				}
	
				return true;
			},
			addToCart(e) {
				e.preventDefault();
	
				document.getElementById('loader').style.display = 'flex';

				const selectedProducts = e.target.closest('.products-bundle').querySelectorAll('input[type="checkbox"]:checked:not(.root-product)');

				if (selectedProducts.length < 1) {
					document.getElementById('loader').style.display = 'none';

					console.error('Failed to find selected bundle products.')

					return;
				}

				const rootProduct = e.target.closest('.products-bundle').querySelectorAll('.root-product');

				if (rootProduct.length < 1) {
					document.getElementById('loader').style.display = 'none';

					console.error('Failed to find bundle root product.')

					return;
				}

				const rootProductId = rootProduct[0].id;

				let products = [];

				selectedProducts.forEach(function (product) {
					products.push(product.id)
				});
	
				const form = new FormData();

				form.append('action', 'add_bundle_products');
				form.append('products', products);
				form.append('rootProductId', rootProductId);
				form.append('nonce', my_ajax_object.nonce);
				form.append('blocksToUpdate', global.getBlocksToUpdate());
				form.append('bundleType', this.bundleType);

				const params = new URLSearchParams(form);

				postData(my_ajax_object.ajax_url, params)
					.then(response => {
						document.getElementById('loader').style.display = 'none';

						if (!response || response.error) {
							return;
						}

						global.updateBlocks(response);

						miniCart.style.display = 'flex';
						document.body.style.overflow = 'hidden';
					});
			}
		}
	}
}
